
export const topicList = [

  ["3. Медицинские науки и общественное здравоохранение", true], // Bold highlight.
  ["3.1 Фундаментальная медицина", true],
  ["3.2 Клиническая медицина", true],
  ["3.3 Науки о здоровье", true],
  ["3.4 Биотехнологии в медицине", true],
  ["3.5 Прочие медицинские науки", true],

  ["1. Естественные и точные науки"],
  ["1.1 Математика"],
  ["1.2 Компьютерные и информационные науки"],
  ["1.3 Физика"],
  ["1.4 Химические науки"],
  ["1.5 Науки о Земле и смежные экологические науки"],
  ["1.6 Биологические науки"],
  ["1.7 Прочие естественные и точные науки"],


  ["2. Техника и технологии"],
  ["2.1 Строительство и архитектура"],
  ["2.2 Электротехника, электронная техника, информационные технологии"],
  ["2.3 Механика и машиностроение"],
  ["2.4 Химические технологии"],
  ["2.5 Технологии материалов"],
  ["2.6 Медицинские технологии"],
  ["2.7 Энергетика и рациональное природопользование"],
  ["2.8 Экологические биотехнологии"],
  ["2.9 Промышленные биотехнологии"],
  ["2.10 Нанотехнологии"],
  ["2.11 Прочие технологии"],

  ["4. Сельскохозяйственные науки"],
  ["4.1 Сельское хозяйство, лесное хозяйство, рыбное хозяйство"],
  ["4.2 Животноводство и молочное дело"],
  ["4.3 Ветеринарные науки"],
  ["4.4 Агробиотехнологии"],
  ["4.5 Прочие сельскохозяйственные науки"],


  ["5. Социальные науки"],
  ["5.1 Психологические науки"],
  ["5.2 Экономика и бизнес"],
  ["5.3 Науки об образовании"],
  ["5.4 Социологические науки"],
  ["5.5 Право"],
  ["5.6 Политологические науки"],
  ["5.7 Социальная и экономическая география"],
  ["5.8 СМИ (медиа) и массовые коммуникации"],
  ["5.9 Прочие социальные науки"],


  ["6. Гуманитарные науки"],
  ["6.1 История и археология"],
  ["6.2 Языкознание и литературоведение"],
  ["6.3 Философия, этика, религиоведение"],
  ["6.4 Искусствоведение"],
  ["6.5 Прочие гуманитарные науки"],
]

